import Header from "@/components/Header";
import Footer from "@/components/Footer";

export const Layout = ({ children, padTop = false }) => {
  return (
    <>
      <Header />
      <main style={padTop ? { paddingTop: "clamp(80px, 11vh, 112px)" } : undefined}>
        {children}
      </main>
      <Footer />
    </>
  );
};

export default Layout;
